/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M350.622 501.63c-7.91 0-15.82-2.688-22.323-8.218L79.186 282.06C71.454 275.505 67 265.854 67 255.69a34.55 34.55 0 0112.186-26.343L328.299 18.2c14.541-12.34 36.352-10.547 48.717 3.993 12.34 14.567 10.522 36.378-4.02 48.717L154.963 255.716l218.035 185.012c14.566 12.339 16.358 34.15 3.993 48.69-6.81 8.065-16.563 12.212-26.368 12.212"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconBracketLeft = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconBracketLeft.defaultProps = {
  theme,
};
IconBracketLeft.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconBracketLeft.displayName = 'IconBracketLeft';
export { IconBracketLeft };
